import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Desregistrar qualquer Service Worker para remover o PWA e limpar o cache
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// Analytics (Google Analytics + PostHog): só com a medição aceite no aviso de
// cookies (23/10/2026). Quem ainda não escolheu vê o aviso (AvisoCookies).
import { initAnalytics } from './lib/analytics'
import { temConsentimentoMedicao } from './lib/consentimentoCookies'
if (temConsentimentoMedicao()) initAnalytics()

// Inicializar serviço de cache de categorias
import './services/cacheUpdateService'

import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { BrowserRouter } from 'react-router-dom'

const root = createRoot(document.getElementById("root")!);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
